import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { findClubsByOwner, IClub } from '../../db';
import { IRootState } from '../../store';
import { setClub } from '../../store/clubReducer';

interface ISelectedClubProps {

}

export const SelectedClub: FC<ISelectedClubProps> = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user, club: { selectedClub }, } = useSelector((state: IRootState) => state);
  const { roles = [] } = user.user;
  const isAdmin = roles.includes('admin');
  const [clubs, setClubs] = useState<Array<IClub>>([]);

  useEffect(() => {
    const clubs = async () => {
      const data = await findClubsByOwner(user.user.metadata!.id, isAdmin);
      setClubs(data);
    };
    clubs().catch((e) => console.error(e));
  }, []);

  return <div className="panel mb-5">
    <div className="flex sm:flex-row flex-col sm:items-center">
      <label htmlFor="horizontalEmail" className="flex sm:w-1/4 sm:mr-2 md:items-center mb-2 sm:mb-0">
        {t('SELECT_CLUB')}
      </label>
      <Select
        className="w-full sm:w-1/2"
        options={clubs?.map(({ _id, clubName }) => {
          return { value: _id, label: clubName };
        })}
        value={selectedClub ? { value: selectedClub._id, label: selectedClub.clubName } : ('' as any)}
        onChange={(data) => dispatch(setClub(clubs.find((club) => club._id === data.value)))}
      />
    </div>
  </div>;
}